var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-module"},[_c('div',{staticClass:"more-module-logo"},[_c('span',[_vm._t("more-logo")],2)]),_vm._v(" "),_c('div',{staticClass:"more-module-name"},[_vm._t("more-name")],2),_vm._v(" "),_c('div',{staticClass:"more-module-intro"},[_vm._t("more-intro")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a882326","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/plugins/MoreModule.vue
// module id = null
// module chunks = 